import { articles, categories, type Article, type Category } from '@/mocks/guagua';

export function formatViews(views: number): string {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)}万`;
  }
  if (views >= 1000) {
    return `${(views / 1000).toFixed(1)}千`;
  }
  return String(views);
}

export function getCategory(slug: string): Category | undefined {
  return categories.find((item) => item.slug === slug);
}

export function getCategoryName(slug: string): string {
  return getCategory(slug)?.name ?? '综合';
}

export function getArticleById(id: string): Article | undefined {
  return articles.find((item) => item.id === id);
}

export function getLatestArticles(count?: number): Article[] {
  const sorted = [...articles].sort((a, b) => (a.date < b.date ? 1 : -1));
  return typeof count === 'number' ? sorted.slice(0, count) : sorted;
}

export function getFeatureArticle(): Article {
  const featured = articles.filter((item) => item.featured);
  return featured[0] ?? articles[0];
}

export function getHotArticles(): Article[] {
  return [...articles].sort((a, b) => b.views - a.views);
}

export function getRelatedArticles(article: Article, count = 3): Article[] {
  const sameCategory = articles.filter(
    (item) => item.categorySlug === article.categorySlug && item.id !== article.id,
  );
  if (sameCategory.length >= count) {
    return sameCategory.slice(0, count);
  }
  const others = articles.filter(
    (item) => item.categorySlug !== article.categorySlug && item.id !== article.id,
  );
  return [...sameCategory, ...others].slice(0, count);
}

export function getAdjacentArticles(article: Article): { prev?: Article; next?: Article } {
  const list = getLatestArticles();
  const index = list.findIndex((item) => item.id === article.id);
  return {
    prev: index > 0 ? list[index - 1] : undefined,
    next: index >= 0 && index < list.length - 1 ? list[index + 1] : undefined,
  };
}

export function getCategoryCount(slug: string): number {
  return articles.filter((item) => item.categorySlug === slug).length;
}